import { pushProductViewItem, pushPromoView, pushPromoClick, pushProductImpression, pushProductClick, pushCleanEcommerceObject } from "./utils";

const PROMO_VIEW = "promoView";

/**
 * Push the product detail view to dataLayer
 */
const pushProductDetailView = () => {
    const pdpImpressionElement = document.querySelector("[data-product-detail-impression]");
    const pdpImpression = pdpImpressionElement?.dataset?.productDetailImpression;
    const pdpImpressionDetail = JSON.parse(pdpImpression);
    document.addEventListener("dataLayer.variantChange", data => {
        if (data?.detail.dataLayerObject) {
            const dataLayerObject = JSON.parse(data.detail.dataLayerObject);
            const listName = $(".gtm-list").data("gtm-list");

            if (listName) {
                dataLayerObject.items.forEach(function (item) {
                    item.item_list_name = listName;
                });
            }
            pushCleanEcommerceObject();
            pushProductViewItem(dataLayerObject);
        }
    });
    pushCleanEcommerceObject();
    pushProductViewItem(pdpImpressionDetail);

    // Product click event for PDP.
    const listName = "impressions";
    if (pdpImpressionElement) {
        const selectors = [
            ".product-images-container .product-images--wrapper",
            ".product-images-container .col-product-tile-badge",
            ".product-images-container .ct-pdp--name",
            ".product-images-container .js-product-price",
            ".product-images-container .ct-pdp--short-wrapper",
            ".js-product-tabs--wrapper",
            ".col-pdp--promo-time-text",
            ".js-product-set-wrapper"
        ];

        selectors.forEach(selector => {
            const elements = pdpImpressionElement.querySelectorAll(selector);
            elements.forEach(element => {
                element.addEventListener("click", (event) => {
                    event.stopPropagation(); // Prevent event from bubbling up
                    pushProductClick([pdpImpressionDetail], listName);
                });
            });
        });
    }
};

/**
 * Pushes the product banners impressions from the pdp.
 */
const pushProductBannersImpressions = () => {
    document.addEventListener("dataLayer.contentLoaded", () => {
        const productBannerImpressions = [...document.querySelectorAll(".image-asset")].map((item, index)=>{
            const image = item.querySelector("img");
            const imageName = image?.dataset?.src.replace(/^.*[\\\/]/, ""); // eslint-disable-line
            const bannerData = Object.assign({}, {
                "id": "product-" + imageName,
                "name": image?.alt,
                "creative": imageName,
                "position": index + 1
            });

            item.addEventListener("click", () => {
                pushPromoClick(bannerData);
            });

            return bannerData;
        }).filter(item => {

            return !!item;
        });

        pushPromoView(productBannerImpressions, PROMO_VIEW);
    });
};

const pushProductSponsoredImpression = () => {
    const productsImpressions = [...document.querySelectorAll(".pd-tile-wrap.product-tile-loaded-sponsored"), ...document.querySelectorAll(".productTile.product-tile-loaded-sponsored")].map(item => {
        if (item.classList.contains("slick-cloned")) {
            return null;
        }
        
        const idx = item?.dataset?.idx;

        let productTileImpression;
        try {
            const productTileData = item.querySelector(".ct-product-tile")?.dataset?.productTileImpression;
            productTileImpression = productTileData ? JSON.parse(productTileData) : null;
        } catch (e) {
            return null;
        }

        if (!productTileImpression) {
            return null;
        }

        const listName = "impressions";
        const productsImpression = Object.assign({}, productTileImpression, {
            "list": listName,
            "position": idx
        });

        const clickImpression = Object.assign({}, productTileImpression, {
            "position": idx
        });

        const descriptionElement = item.querySelector(".pwc-tile--description");
        if (descriptionElement) {
            descriptionElement.addEventListener("click", () => {
                pushProductClick([clickImpression], listName);
            });
        }

        const tileImageElement = item.querySelector(".ct-tile-image");
        if (tileImageElement) {
            tileImageElement.addEventListener("click", () => {
                pushProductClick([clickImpression], listName);
            });
        }

        return productsImpression;
    }).filter(item => item);

    if (productsImpressions.length) {
        pushProductImpression(productsImpressions);
    }
};

const initDatalayer = () => {
    pushProductDetailView();
    pushProductBannersImpressions();
};

module.exports = {
    initDatalayer : initDatalayer,
    pushProductSponsoredImpression: pushProductSponsoredImpression
};
